import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {HttpClient, HttpParams} from '@angular/common/http';
import {AppService} from '../../../../appService';
import {environment} from '../../../../../environments/environment';
import {ToastsManager} from 'ng2-toastr';

@Component({
  selector: 'app-meeting-with-student-by-dean',
  templateUrl: './meeting-with-student-by-dean.component.html',
  styleUrls: ['./meeting-with-student-by-dean.component.css']
})
export class MeetingWithStudentByDeanComponent implements OnInit {
  reasonForMeetingOrSemesterFilter: any = '';

  teacherId: any = '';
  studentId: any = '';
  semesterList: any = [];
  selectedSemesterIdToSearchMeeting = '';
  meetingList: any = [];

  date = new Date();
  cdnLocMentoring= environment.cdnLocMentoring;

  constructor(private appService: AppService,
              private localStorage: LocalStorageService,
              private sessionStorage: SessionStorageService,
              private route: ActivatedRoute,
              private router: Router, private httpClient: HttpClient,  public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    this.appService.hasAccessToken();
    this.route.params.subscribe((params: Params) => {
      this.studentId = params['studentId'];
      this.teacherId = params['teacherId'];
    });

    this.getSemesterList();

    // console.log(this.studentId);
    // console.log(this.teacherId);
  }

  getSemesterList() {
    const myParams = new HttpParams();
    this.httpClient.get(environment.apiUrl + 'deanAccess/semesterList', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          // console.log(res);
          this.semesterList = res;
        },
        msg => {
          console.error('error');
        }
      );
  }


  getMeetingList() {
    const myParams = new HttpParams().append('studentId', this.studentId)
      .append('semesterId', this.selectedSemesterIdToSearchMeeting)
      .append('teacherId', this.teacherId);

    this.httpClient.get(environment.apiUrl + 'deanAccess/teacherMeetingStudent/meetingList', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    })
      .subscribe(res => {
          // console.log(res);
          this.meetingList = res;
        },
        msg => {
          console.error('error');
        }
      );

  }

}
